import { IconFlagDE, IconFlagES, IconFlagFR, IconFlagPT, IconFlagSl, IconFlagUS } from '@/assets/static/icons';

export const languages = [
  {
    label: 'EN',
    flag: <IconFlagUS />,
    value: 'en',
    lang: 'English',
  },
  {
    label: 'DE',
    flag: <IconFlagDE />,
    value: 'de',
    lang: 'Deutsch',
  },
  {
    label: 'ES',
    flag: <IconFlagES />,
    value: 'es',
    lang: 'Spanish',
  },
  {
    label: 'FR',
    flag: <IconFlagFR />,
    value: 'fr',
    lang: 'French',
  },
  {
    label: 'PT',
    flag: <IconFlagPT />,
    value: 'pt',
    lang: 'Portugese',
  },
  {
    label: 'SL',
    flag: <IconFlagSl />,
    value: 'sl',
    lang: 'Slovenian',
  },
] as const;
